import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  ASSIGN_WIDGET_TO_ENTITY_TYPE,
  GET_ASSIGNED_WIDGETS,
  get_headers,
  get_project_id,
  GET_WIDGETS,
  ROLES_URL,
  UNASSIGN_WIDGET_FROM_ENTITY_TYPE,
} from "@/utils/constants/constants.js";
import axios from 'axios';

import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import WidgetManagement from "@/views/probaworkflows_base/management/entity_management/entity_type_widgets/WidgetManagement.vue";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";

export default {
  name: "ViewEntityType",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    NavigationBackButton,
    WidgetManagement
  },
  data: () => ({
    headers: null,
    project_id: get_project_id(),
    entity_type_id: sessionStorage.getItem("entity_type_id"),
    entity_type_name: sessionStorage.getItem('entity_type_name'),
    selected_widget: [],
    available_widgets: [],
    widget_headers: [],
    assigned_widgets: [],
    roles: [],
    selected_role: null,
  }),
  mounted() {
    this.headers = get_headers();
    this.get_roles();
    this.get_widgets();
    this.get_assigned_widgets();
  },
  methods: {
    get_roles() {
      const query_params = { project_id: this.project_id }
      axios
        .get(ROLES_URL, { headers: this.headers, params: query_params })
        .then((response) => {
          const response_data = response.data.data;

          this.roles = response_data.map((role) => ({
            id: role.id,
            name: role.role,
          }));

          if (this.roles.length > 0) {
            this.selected_role = this.roles[0].id;
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load roles";
          this.show_error(message);
        });
    },

    get_widgets() {
      axios
        .get(GET_WIDGETS, { headers: this.headers })
        .then((response) => {
          const response_data = response.data;
          this.available_widgets = response_data.map((widget) => ({
            id: widget.id,
            name: widget.widget_display_name,
            description: widget.widget_description || "",
          }));

          this.widget_headers = Object.keys(this.available_widgets[0] || {});
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load widgets";
          this.show_error(message);
        });
    },

    get_assigned_widgets() {
      const params = {
        entity_type_id: this.entity_type_id
      };

      if (this.selected_role !== null) {
        params.role_id = this.selected_role;
      }

      axios
        .get(GET_ASSIGNED_WIDGETS, { params, headers: this.headers })
        .then((response) => {
          const data = response.data;
          this.assigned_widgets = data.map((item) => item.widget.id);
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load assigned widgets";
          this.show_error(message);
        });
    },

    on_role_change() {
      this.get_assigned_widgets();
    },

    toggle_assignment(widget_id, is_assigned) {
      const endpoint = is_assigned
        ? ASSIGN_WIDGET_TO_ENTITY_TYPE
        : UNASSIGN_WIDGET_FROM_ENTITY_TYPE;

      const payload = {
        entity_type_id: this.entity_type_id,
        widget_id: widget_id,
      };

      if (this.selected_role !== null) {
        payload.role_id = this.selected_role;
      }

      axios
        .post(endpoint, payload, { headers: this.headers })
        .then((response) => {
          if (response.data.is_assigned) {
            if (!this.assigned_widgets.includes(widget_id)) {
              this.assigned_widgets.push(widget_id);
            }
          } else {
            this.assigned_widgets = this.assigned_widgets.filter(
              (id) => id !== widget_id
            );
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to toggle widget assignment";
          this.show_error(message);
        });
    },
  }
};